import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=9e821cc4&scoped=true"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e821cc4",
  null
  
)

export default component.exports